export default {
  approved: 'Aprobat',
  rejected: 'Respins',
  cancelled: 'Anulat',
  generated: 'Generat',
  disabled: 'Dezactivat',
  approvalReady: 'Așteptare aprobare',
  avizo: 'În proces de avizare',
  withdrawn: 'Retras',
  asteptare_editare_in_urma_anularii_de_catre_un_administrator:
    'Așteptare editare în urma anulării de către un administrator',
}